"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRootStyles = void 0;
const react_1 = require("@griffel/react");
exports.useRootStyles = react_1.__styles({
  "root": {
    "B8gzw0y": "f1dd5bof"
  }
}, {
  "m": [["@media (forced-colors: active){.f1dd5bof{forced-color-adjust:auto;}}", {
    "m": "(forced-colors: active)"
  }]]
});